import React from 'react';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';


import TouchableExternalLink from '../TouchableExternalLink';
import { useColors } from '../../contexts/theme';
import MenuButton from './MenuButton';


const styles = {
  icon: { marginRight: 10 },
};

const ActionsMenu = ({ actions }) => {
  const colors = useColors();

  return actions && actions.length > 0 ? actions.length === 1 ? (
    <TouchableExternalLink
      url={actions[0].url}
      containsIcon
      style={styles.icon}
    >
      <Icon
        name='link-box'
        color={colors.secondary}
        size={30}
      />
    </TouchableExternalLink>
  ) : (
    <MenuButton actions={actions} />
  ) : null;
};

export default ActionsMenu;
